import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import classes from "./styles/style.module.css";
import CustomModal from "../../../assets/components/ModalComonent";
import CheckImg from "../../../assets/images/common/checkVector.svg";
import CrossImg from "../../../assets/images/common/crossGroup.svg";
import { setQuestionAnswered } from "../../../assets/redux/actions/Quiz";
import CustomButton from "../../../assets/components/CustomButton";

import CuurectSound from "../../../assets/Audio/win.mp3";
import FlaseSound from "../../../assets/Audio/lose.mp3";

export default function AnswerQuestion() {
  const [show, setShow] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false);
  const [score, setScore] = useState(0);
  const { answeredQuestion } = useSelector(({ quiz }) => quiz);
  const dispatch = useDispatch();

  const winAudio = new Audio(CuurectSound);
  const lossAudio = new Audio(FlaseSound);

  useEffect(() => {
    if (answeredQuestion) {
      setShow(true);
      setIsCorrect(answeredQuestion.rightAnswer);
      if (answeredQuestion.rightAnswer) {
        setScore(answeredQuestion.score);
      }
    }

    return () => {
      dispatch(setQuestionAnswered(null));
    };
  }, [answeredQuestion]);

  useEffect(() => {
    const soudMuted = JSON.parse(localStorage.getItem("soudMuted"));
    if (show && soudMuted) {
      if (isCorrect) {
        winAudio.play();
      } else {
        lossAudio.play();
      }
    }
  }, [show, isCorrect]);

  // useEffect(() => {
  //   if (show) {
  //     setTimeout(() => {
  //       handleClose();
  //     }, 4000);
  //   }
  // }, [show]);

  const handleClose = () => {
    window.history.back();
    setShow(false);
    dispatch(setQuestionAnswered(null));
  };

  const rightAnswerDialog = (
    <div className="w-100 text-center">
      <img src={CheckImg} alt="check-vector" className={classes.alertBanner} />
      <p className={classes.title}>پاسخ صحیح</p>
      <div className={classes.dialogContent}>
        <p className="text-center">پاسخ شما صحیح بود !!!</p>
        <p className="text-center">{`${score} پله دریافت کردی `}</p>
      </div>
      <div className="w-100 mt-4">
        <CustomButton
          clickHandler={handleClose}
          color={"primary"}
          shadow
          text={"بستن"}
        />
      </div>
    </div>
  );

  const falseAnswerDialog = (
    <div className="w-100">
      <img src={CrossImg} alt="check-vector" className={classes.alertBanner} />
      <p className={classes.title}>پاسخ اشتباه</p>
      <div className={classes.dialogContent}>
        <p className="text-center">پاسخ شما اشتباه بود !!!</p>
      </div>
      <div className="w-100 mt-4">
        <CustomButton
          clickHandler={handleClose}
          color={"primary"}
          shadow
          text={"بستن"}
        />
      </div>
    </div>
  );

  return (
    <CustomModal
      open={show}
      closeHandler={handleClose}
      inputDialog={true}
      dialogContent={isCorrect ? rightAnswerDialog : falseAnswerDialog}
    />
  );
}
